import React from 'react';
import type EditWorkflow from '@jira/admin-pages__edit-workflow/src/EditWorkflow.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyEditWorkflow = lazyForPaint<typeof EditWorkflow>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-edit-workflow", jiraSpaEntry: "async-admin-pages-edit-workflow" */ '@jira/admin-pages__edit-workflow/src/EditWorkflow.tsx'
		),
	),
);

const AsyncEditWorkflow = (): React.JSX.Element => (
	<LazyPage Page={LazyEditWorkflow} pageId="jira-admin-pages-edit-workflow" shouldShowSpinner />
);

export default AsyncEditWorkflow;
